<div class="flex flex-wrap">
  @if (global) {
    <app-indicator-children-dropdown />
  }
</div>
<div class="p-datatable-wrapper" *ngIf="data">
  <div class="flex align-items-start mb-3">
    @if (
      data.avg !== undefined ||
      data.total !== undefined ||
      comparisonStore.withoutDefaultAsArray().length
    ) {
      <div class="p-card surface-ground p-3 flex flex-column gap-2 mb-3">
        @if (data.avg !== undefined || hasErrors('avg') || hasWarnings('avg')) {
          <div
            class="flex align-items-start gap-2 font-italic"
            [class]="
              hasErrors('avg')
                ? 'font-bold text-red-500'
                : hasWarnings('avg')
                  ? 'font-bold text-yellow-500'
                  : 'text-color-secondary'
            ">
            <div class="w-8rem"><code>avg</code></div>
            <div class="w-10rem">Durchschnitt</div>
            <div>
              <span
                >{{
                  hasErrors('avg')
                    ? getErrorValue('avg') + ' (wird als k. A. importiert)'
                    : (data.avg | safeNumber: data.indicator)
                }}
                @if (data['warning']?.oldValues?.['avg']; as oldValue) {
                  <i class="font-light"
                    >(vorher: {{ oldValue | safeNumber: data.indicator }})</i
                  >
                }
              </span>
            </div>
          </div>
        }

        @if (
          data.total !== undefined || hasErrors('total') || hasWarnings('total')
        ) {
          <div
            class="flex align-items-center gap-2 font-italic"
            [class]="
              hasErrors('total')
                ? 'font-bold text-red-500'
                : hasWarnings('total')
                  ? 'font-bold text-yellow-500'
                  : 'text-color-secondary'
            ">
            <div class="w-8rem"><code>total</code></div>
            <div class="w-10rem">Gesamt</div>
            <div>
              <span
                >{{
                  hasErrors('total')
                    ? getErrorValue('total') + ' (wird als k. A. importiert)'
                    : (data.total | safeNumber: data.indicator)
                }}
                @if (data['warning']?.oldValues?.['total']; as oldValue) {
                  <i class="font-light"
                    >(vorher: {{ oldValue | safeNumber: data.indicator }})</i
                  >
                }
              </span>
            </div>
          </div>
        }

        @for (
          compVal of comparisonStore.withoutDefaultAsArray();
          track $index
        ) {
          @if (data.data[compVal.key]) {
            <div
              class="flex align-items-center gap-2 font-italic"
              [class]="
                hasErrors(compVal.key)
                  ? 'font-bold text-red-500'
                  : hasWarnings(compVal.key)
                    ? 'font-bold text-yellow-500'
                    : 'text-color-secondary'
              ">
              <div class="w-8rem">
                <code>{{ compVal.key }}</code>
              </div>
              <div class="w-10rem">{{ compVal.name }}</div>
              <div
                [innerHTML]="
                  data.data[compVal.key] | safeNumber: data.indicator
                "></div>
            </div>
          }
        }
      </div>
    }

    <app-search-input
      class="ml-auto"
      [disabled]="!data"
      (search)="filterFeatures($event)"></app-search-input>
  </div>

  <p-table
    [value]="filteredDistrictsArray"
    [paginator]="filteredDistrictsArray.length >= 10"
    [rows]="10"
    [tableStyle]="{ 'min-width': '50rem' }"
    [rowsPerPageOptions]="[10, 25, 50, 100]"
    [scrollable]="true"
    scrollHeight="35rem">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 8rem"><i class="fas fa-key"></i></th>
        <th style="width: 10rem">Name</th>
        <th>Wert</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-district>
      <tr
        [class]="
          hasErrors(district.key)
            ? 'font-bold text-red-500'
            : hasWarnings(district.key)
              ? 'font-bold text-yellow-500'
              : 'text-color-secondary'
        ">
        <td>
          <code>{{ district.key }}</code>
        </td>
        <td>{{ district.name }}</td>
        <td>
          <span
            >{{
              hasErrors(district.key)
                ? getErrorValue(district.key) + ' (wird als k. A. importiert)'
                : (data.data[district.key] | safeNumber: data.indicator)
            }}
            @if (data['warning']?.oldValues?.[district.key]; as oldValue) {
              <i class="font-light"
                >(vorher: {{ oldValue | safeNumber: data.indicator }})</i
              >
            }
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
